

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <DatosEmpresa></DatosEmpresa>
</v-col>
</v-row>  


<v-row justify="end" >
        
        <v-col cols="2" >





        </v-col>
      </v-row>



</v-container>
   
</div>
</template>

<script>

import DatosEmpresa from '@/components/economy/DatosEmpresa.vue';




export default {
    data () {
    return {
             
    }
  },
  components: {
    
    DatosEmpresa
    
  },
  mounted(){

  


  },

  methods: {

    

}

}
    

</script>


